import { DatePicker, Space, Select, Table, message, Spin, Form, Image, Tooltip, Button, Popconfirm, Divider, Input } from 'antd';
import constants from '../../constants/constants';
import { useContext, useEffect, useState } from 'react';
import WebLinks from '../../api/WebLinks';
import Cookies from 'js-cookie';
import APIUtils from '../../api/APIUtils';
import { DeleteOutlined} from '@ant-design/icons';
import { CommonContext } from '../../Context';
const { Option } = Select

const JobsAutomateBoosts = (props) => {

	//Variable declaration
	const commonContext=useContext(CommonContext);
	const buyerId = commonContext.common.buyerId;
	const columns = [
		{
			title: '',
			dataIndex: 'post',
			key: 'post',
      render: (_, record) => {
				return (
					<>
						<span>{constants.PostAllNewJobsTO}</span>
					</>
				)
			}
		},
		{
			title: constants.SelectBoosts,
			dataIndex: 'productName',
			key: 'productName',
			//align: 'center',
			render: (_, record) => {
				return (
					<>
						<span>{record?.productName}</span>
					</>
				)

			}
		},
		{
			title: constants.IfJobTitleContains,
			dataIndex: 'jobTitleContains',
			key: 'jobTitleContains',
			//align: 'center',
			render: (_, record) => {
				return (
					<Space size={3}>
						<span>{record?.jobTitleContains||"All Jobs"}</span>
					</Space>
				)

			}
		},
		{
			title: '',
			dataIndex: 'action',
			key: 'action',
			align: 'center',
      render: (_, record) =>
      <Tooltip title="Delete" placement='bottom'>
          <Popconfirm title="Sure you want to delete?" onConfirm={() => handleDelete(record)} placement="left">
              <Button icon={<DeleteOutlined />} type="link"  size='large' />
          </Popconfirm>
      </Tooltip>
		},

	];
	const [boostAutomateData, setBoostAutomateData] = useState([]);
	const [boostSelectData, setBoostSelectData] = useState([]);
	const [loader, setLoader] = useState(false);
	const [form] = Form.useForm();

	useEffect(() => {
		GetBoostAutomateData();
		GetBoostSelectData();
	}, []);


	//Functions

  //Delete record
	const handleDelete = async(record) => {
		const deleteResponse = await APIUtils.apiCall("DELETE",WebLinks.DeleteAutomatedBoosts+record.id);
		if(deleteResponse.isCatch || deleteResponse?.resultObj?.statusCode!=='2000'){
			message.error( deleteResponse?.resultObj?.message || constants.ERROR_MESSAGE);
		}else{
      GetBoostAutomateData();
      message.success(deleteResponse?.resultObj?.message)
    }
	};

	//Function to get data
	const GetBoostAutomateData = async () => {
		setLoader(true);
		const response = await APIUtils.apiCall('GET', WebLinks.GetAutomatedBoosts + buyerId );
		if (!response.isCatch && response.resultObj.statusCode === "2000") {
			setBoostAutomateData(response.resultObj.data);
			setLoader(false);
		} else {
			setBoostAutomateData([]);
			setLoader(false);
			message.error(response.resultObj.message);
		}
	}

	const GetBoostSelectData = async () => {
		const response = await APIUtils.apiCall('GET', WebLinks.GetBoostSelectionData + buyerId );
		if (!response.isCatch && response.resultObj.statusCode === "2000") {
			setBoostSelectData(response.resultObj.data);
		} else {
			setBoostSelectData([]);
			message.error(response.resultObj.message);
		}
	}

	//Function to post data
	
	const onFinish = async(values) => {
		let tempValues=values?.boost?.split("-");
		let payload=null;
		payload={
			buyerId: buyerId,
			boostProductId: tempValues[0],
			jobTitleContains: values?.jobTitleContains || "",
			locationContains: null,
			supplierId: tempValues[1]
		}
		const response = await APIUtils.apiCall('POST',WebLinks.PostAutomateBoostDetails,JSON.stringify(payload) );
		if (!response.isCatch && response.resultObj.statusCode === "2000") {
			  GetBoostAutomateData();
				message.success(response.resultObj.message)
		} else {
				message.error(response.resultObj.message)
		}
};

	return (
			<Spin spinning={loader}>
				<div>
					<div className='flex flex-wrap gap-3 justify-between items-center mb-3'>
          <div className='uppercase font-semibold text-xl'>Auto POST JOBS</div>
          <Divider/>
          <Form
					form={form}
					layout="vertical"
					onFinish={onFinish}
					className="flex items-start gap-4"
					>
				<label className=" font-semibold uppercase mb-0 mt-7">
							Post All New Jobs To
					</label>

        <Form.Item
          label="Select Boost"
          name="boost"
          className="mb-0 w-60"
					rules={[
            {
              required: true,
              message: 'Please select boost',
            },
          ]}
        >
          <Select>
					{boostSelectData.map((item) => (
                  <Option key={item.id} value={item.id+"-"+item.supplierId}>{item.productName}</Option>
                ))}
					</Select>
        </Form.Item>

        <div>
          <Form.Item
            label="If Job Title Contains"
            name="jobTitleContains"
            className="mb-0"
          >
            <Input  />
          </Form.Item>

          <p className="mt-1 text-[9px] text-gray-500">
            * Leave blank for All Jobs
          </p>
        </div>

        <Form.Item className="mb-0 mt-8">
          <Button
            htmlType="submit"
            type='primary'
            //size="small"
            className=""
          >
            Create
          </Button>
        </Form.Item>
      </Form>
            <Divider/>
					</div>
          <div className='uppercase font-semibold text-xl mb-1'>LIVE AUTOMATIONS</div>

					<div className='overflow-x-auto'>
						<Table
							columns={columns}
							dataSource={boostAutomateData}
							scroll={{
								x: 1000,
							}}
							sortDirections={['descend', 'ascend', 'descend']}
              pagination={false}
						/>
					</div>
				</div>
			</Spin>
	);
};

export default JobsAutomateBoosts;